import { render, staticRenderFns } from "./SafeActivation.vue?vue&type=template&id=5266d0d6&scoped=true&"
import script from "./SafeActivation.vue?vue&type=script&lang=js&"
export * from "./SafeActivation.vue?vue&type=script&lang=js&"
import style0 from "./SafeActivation.vue?vue&type=style&index=0&id=5266d0d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5266d0d6",
  null
  
)

export default component.exports